// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:33:49

export default {
  "id": "fish-land-fish-world",
  "slug": "fish-land-fish-world",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/21bf8b3cab7a46fab687bcb6485af5f1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/21bf8b3cab7a46fab687bcb6485af5f1/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Fish Land Fish World",
      "description": "Explore a colorful underwater world full of fishing excitement. In Fish Land - Fish World, you’ll become a fishing expert in this relaxing idle fishing adventure! This game combines simulation and fishing elements. Allow you to fish, expand your pond, and grow your aquatic world.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Adventure",
        "Simulation"
      ],
      "tags": [
        "arcade",
        "catch",
        "fishing"
      ]
    },
    "zh-CN": {
      "title": "鱼之岛 鱼世界",
      "description": "探索一个充满钓鱼乐趣的五颜六色的水下世界。在《鱼乡 - 鱼世界》中，你将成为这个轻松休闲的钓鱼冒险中的钓鱼大师！这款游戏结合了模拟和钓鱼元素。让你体验钓鱼、扩建池塘，以及壮大你的水世界。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "冒险",
        "模拟"
      ],
      "tags": [
        "街机",
        "捕捉",
        "钓鱼"
      ]
    },
    "zh-TW": {
      "title": "魚之國家 魚之世界",
      "description": "探索充滿釣魚樂趣的多彩海底世界。在《魚樂園 - 魚界》，你將成為這個放鬆的怠靜釣魚冒險中的釣魚專家！這款遊戲結合了模擬和釣魚元素。讓你可以釣魚、擴張你的池塘，並成長你的水生世界。",
      "instructions": "滑鼠點擊或觸控以遊玩",
      "genres": [
        "冒險",
        "模擬"
      ],
      "tags": [
        "電玩",
        "捕獲",
        "釣魚"
      ]
    },
    "zh-HK": {
      "title": "魚樂園 魚世界",
      "description": "探索充滿釣魚樂趣的多彩海底世界。在《魚樂園 - 魚世界》中，你將成為這個放鬆的怠惰釣魚冒險中的釣魚專家！這款遊戲結合了模擬和釣魚元素。讓你釣魚、擴張你的池塘，並成長你的水生世界。",
      "instructions": "滑鼠點擊或輕觸以遊玩",
      "genres": [
        "冒險",
        "模擬"
      ],
      "tags": [
        "街機",
        "捕獲",
        "釣魚"
      ]
    },
    "ja": {
      "title": "フィッシュランド フィッシュワールド",
      "description": "カラフルな水中の世界を探検し、釣りの興奮に浸ろう。Fish Land - Fish Worldでは、リラックスしたアイドル釣りアドベンチャーで釣り専門家になる！このゲームはシミュレーションと釣り要素を組み合わせています。釣り、池を拡張し、水中の世界を育成することができます。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "アドベンチャー",
        "シミュレーション"
      ],
      "tags": [
        "アーケード",
        "キャッチ",
        "フィッシング"
      ]
    },
    "ko": {
      "title": "fish 랜드 페쉬 월드",
      "description": "색다른 하늘 아래 물속 세계를 탐험하세요. Fish Land - Fish World에서는 이 편안한 잠시의 피싱 모험에서 피싱 전문가가 됩니다! 이 게임은 시뮬레이션과 피싱 요소를 결합하여, 물고기를 잡고, 호수를 확장하고, 수중 세계를 키울 수 있습니다.",
      "instructions": "마우스 클릭이나 탭으로 게임 시작",
      "genres": [
        "모험",
        "시뮬레이션"
      ],
      "tags": [
        "아케이드",
        "잡기",
        "낚시"
      ]
    },
    "fr": {
      "title": "Terre des Poissons Monde des Poissons",
      "description": "Explorez un monde sous-marin coloré plein de joie de pêche. Dans Fish Land - Fish World, devenez un expert en pêche dans cette aventure de pêche tranquille et passive ! Ce jeu combine des éléments de simulation et de pêche. Permettez-vous de pêcher, d'agrandir votre étang et de développer votre monde aquatique.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Aventure",
        "Simulation"
      ],
      "tags": [
        "arcade",
        "attraper",
        "pêche"
      ]
    }
  }
};
